import { uuid25 } from "../../uuid/dist/uuid25.js";
import { deepMerge } from "../deepMerge.js";
//#region src/utils/collection/table.entity.ts
var createTable = (value) => deepMerge({
	id: uuid25(),
	name: "",
	logicalName: "",
	comment: "",
	columnIds: [],
	seqColumnIds: [],
	groupId: "",
	nameDerived: false,
	ui: {
		x: 200,
		y: 100,
		zIndex: 2,
		widthName: 60,
		widthLogicalName: 60,
		widthComment: 60,
		color: ""
	}
}, value ?? {});
//#endregion
export { createTable };
